<template>
  <div class="main">
    <div class="box">
      <div class="header">
        采购申请  
      </div>
      <div class="table">
        <div class="table-top">
          <div class="grid-search">
              <!-- <el-date-picker
                  v-model="search.date"
                  align="right"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  style="margin-right:1vw;"
                  @change="doFilter"
              ></el-date-picker> -->
              <el-input v-model="name" style="width:200px" placeholder="请输入订单编号" clearable @change="doFilter">
                <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
              </el-input>
            </div>
            <div class="btns">
              <button class="addwuzi" style="margin-right:10px" @click="addItem">采购申请</button>
            </div>
        </div>
        <div class="cont-box">
          <div class="title">
          <div class="item" style="width:8%;">序号</div>
          <div class="item" style="width:18%;">订单编号</div>
          <div class="item" style="width:18%;">申请人</div>
          <div class="item" style="width:18%;">申请时间</div>
          <div class="item" style="width:18%;">状态</div>
          <div class="item" style="width:18%;">备注</div>
          <div class="item" style="width:12%;">操作</div>
        </div>
        <div class="scroll">
          <div class="content-i" v-for="(item,index) in listData" :key="index">
          <div class="text" style="width:8%;">{{(currentPage-1)*pageSize+index+1}}</div>
          <div class="text" style="width:18%;">{{item.orderNumber}}</div>
          <div class="text" style="width:18%;">{{item.createName}}</div>
          <div class="text" style="width:18%;">{{item.createDate}}</div>
          <div class="text" style="width:18%;">{{item.status=='0'?'进行中':item.status=='1'?'未通过':'已通过'}}</div>
          <div class="text" style="width:18%;">{{item.remarks}}</div>
          <div class="text" style="width:12%;">
            <div class="btns1">
              <div class="btn1" @click="entData(item)">详情</div>
              <div class="btn1" @click="entIdData(item)">物料清单</div>
            </div>
          </div>
        </div>
        </div>
        </div>
        <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50,100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
        <el-dialog center width="500px" title="详情" :visible.sync="modifyVisible" append-to-body :before-close="close">
          <div >
            <el-steps direction="vertical" :active="active">
              <el-step v-for="(item,index) in state" :key="index">
                <span slot="description">处理人：{{item.handlerName }}（{{item.officeName}}）</span>
                <span slot="description">处理状态：{{item.status=='0'?'等待处理':item.status=='1'?'正在处理':item.status=='2'?'处理结束':''}}</span>
                <span slot="description" :style="item.handlerStatus==='2'?'color:#f00':''">处理结果：{{item.handlerStatus==='0'?'待处理':item.handlerStatus==='1'?'处理通过':item.handlerStatus==='2'?'不通过':''}}</span>
                <span slot="description">处理信息：{{item.handlerMsg}}</span>
              </el-step>
            </el-steps>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
export default {
  data() {
    return {
      listData: [
        // {index:'1',id:'1',name:'便携呼吸机',num:'2',around:'仓库',createDate:'2021-07-08'},
        // {index:'2',id:'2',name:'雨衣',num:'5',around:'仓库',createDate:'2021-07-08'},
        // {index:'3',id:'3',name:'绷带',num:'10',around:'仓库',createDate:'2021-07-08'},
        // {index:'4',id:'4',name:'止疼药',num:'10',around:'仓库',createDate:'2021-07-08'},
      ],
      search: {
        //查询
        pageSize:0,
        pageNum:0,
      },
      groupId: '',
      dataText: '数据加载中...',
      
      currentPage: 1,
      pageSize: 10,
      totalItems: 4,
      modifyVisible: false,
      workerInfo: {
        id: '',
        name:'',
        count:0,
        place:'',
        remarks:'',
        createBy:'',
        projectId:''
      },
      rules:{
        name:[
           { required: true, message: '请输入', trigger: 'blur' }
        ],
        count:[
           { required: true, message: '数量不能为空'}
        ]
      },
      //检查事项列表
      napeList:[],
      //责任单位
      entList:[],
      //责任人
      personList:[],
      //使用列表
      listHistory:[],
      dataText1:'数据加载中...',
      hisVis:false,
      num:0,
      num1:0,
      total:0,
      name:'',
      state:[],
      active:0,
      projectId:''
    }
  },
  created() {
    this.groupId = util.session.get('groupId')
    this.projectId = util.session.get('groupId')
  },
  mounted() {
    // this.search.projectId = this.groupId
    // if (this.search.projectId == '') {
    //   this.$store.commit('setGroupId')
    //   this.search.projectId = this.$store.state.groupId
    // }
    // this.getNapeList()
    // this.getEntList()
    // this.getPerosn()
    this.groupId = util.session.get('groupId')
    this.getData()
  },
  methods: {
    close(done){
      this.state = []
      done()
    },
    entData(item){
      this.modifyVisible = true
      myHttp.findProjectPurchaseProcessList({
        planPurchaseId:item.id
      }).then(res=>{
        if(res.data.code==200){
          let list = res.data.data.projectPurchaseProcessList
          let indexD =1
          list.forEach((item,index)=>{
            if(item.handlerStatus==='2'){
              this.state.push(item)
              indexD=2
            }
            if(indexD===1){
              this.state.push(item)
              let indexS =1
              if(item.status=='1'){
              this.active = index
              indexS=2
            }else if(item.status=='2'){
              if(indexS!==2){
                this.active = index+2
              }
            }
            }
          })
          // this.state = res.data.data.projectPurchaseProcessList
        }
      })
    },
    addItem(){
      this.$router.push({
        path:'/orderEditing'
      })
    },
    entIdData(item){
      let that = this
      this.$router.push({
        path:'/orderData',
        query:{
          orderNumber:item.orderNumber,
          projectId:that.groupId
        }
      })
    },
    handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
        this.getData()
    },
    // 搜索数据
    doFilter(index) {
      this.search.orderNumber = this.name
      this.getData()
    },
    // 获取数据
    getData(){
      let that = this
      this.search.projectId = this.projectId
       this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      myHttp.getProProjectPurchasePlanPage(this.search).then(res=>{
        console.log(res)
        if(res.data.code===200){
          that.listData = res.data.data.pageInfo.list
          that.total = res.data.data.pageInfo.total
        }
      })
    },
    // getData() {
    //   var that = this
    //   this.search.pageSize = this.pageSize
    //   this.search.pageNum = this.currentPage
    //   myHttp.selectProEmergencySuppliesPage(this.search).then(
    //     function(resp) {
    //       if (resp.data.code == '200') {
    //         var list = resp.data.data.pageInfo.list || []
    //         for(var i=0;i<list.length;i++){
    //           list[i].index = (i+1)+(that.currentPage-1)*that.pageSize
    //         }
    //         that.listData = list
    //         if (that.listData.length == 0) {
    //           that.dataText = '暂无数据'
    //         }else{
    //           that.totalItems = resp.data.data.pageInfo.total||0
    //         }
    //       } else {
    //         that.$message.error(resp.data.msg)
    //         that.dataText = '暂无数据'
    //       }
    //     },
    //     function() {}
    //   )
    // },
    
    //添加计划
    addPlan(){
      this.modifyVisible = true
      this.workerInfo.id = ''
      this.workerInfo.name = ''
      this.workerInfo.count = ''
      this.workerInfo.place = ''
      this.workerInfo.remarks = ''
      this.workerInfo.createBy = ''
      this.workerInfo.projectId = ''
    },
    //编辑
    updateFun(row){
      console.log(row)
      this.modifyVisible = true
      this.workerInfo.id = row.id
      this.workerInfo.name = row.name
      this.workerInfo.count = row.count
      this.workerInfo.place = row.place
      this.workerInfo.remarks = row.remarks
    },
    /**
     * 判断是否展示
     */
    isMenuExit(row){
        var flag = util.common.filterBtnMenu(row)
        return flag
    },
    /**
     * 提交
     */
    modifyWorkerInfo(formName){
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.workerInfo.projectId = this.groupId
          that.workerInfo.createBy = util.session.get('user').id
          if(that.workerInfo.id == ''){
            myHttp.createProEmergencySupplies(that.workerInfo).then(function(resp){
              // console.log(resp)
              if(resp.data.code=='200'){
                that.$message.success('提交成功')
                that.modifyVisible = false
                that.getData()
              }else{
                that.$message.error(resp.data.msg)
              }
            })
          }else{
            that.workerInfo.updateBy = util.session.get('user').id
            myHttp.updateProEmergencySupplies(that.workerInfo).then(function(resp){
              if(resp.data.code=='200'){
                that.$message.success('提交成功')
                that.modifyVisible = false
                that.getData()
              }else{
                that.$message.error(resp.data.msg)
              }
            })
          }
        } else {
          return false
        }
      })
    },
    /**
     * 查看
     */
    sumbitInfo(row){
      // this.$router.push({path:'/planProHis/'+row.id})
      this.hisVis = true
      var that = this
      myHttp.selectProEmergencyProcessingDetailsList({
        suppliesId:row.id,
        projectId:this.groupId
      }).then(function(resp){
        console.log(resp)
        if(resp.data.code=='200'){
          var list = resp.data.data.proEmergencyProcessingDetailss||[]
          that.listHistory = list
          if(list.length==0){
            that.dataText1 = '暂无数据'
          }
        }
      })
    },

  }
}
</script>
<style>
  @import '../../../assets/css/common.css';
</style>
<style scoped>
.main{
  flex: 1;
  height: 100%;
  background-color: #F3F8FC;
  padding-left:8px ;
  padding-right:24px ;
}
.table{
  height: 83vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0vw 0vw 0.4vw 0vw 
		rgba(105, 159, 204, 0.5);
}
.table::-webkit-scrollbar{
  width: 0;
  height: 0;
}
.scroll{
  height: 66vh;
  overflow: scroll;
}
.scroll::-webkit-scrollbar{
  width: 0;
  height: 0;
}
.table-top{
  min-height: 6vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 9px 0 9px;
}
.addwuzi{
  background-color: #0b62f0;
  color: #fff;
  width: 90px;
  height: 4vh;
  font-family: PingFang-SC-Medium;
	font-size: 16px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.addwuzi:hover{
  opacity: 0.6;
}
.title{
  height: 6vh;
  min-height: 6vh;
  background-color: #dfe1e3;
  display: flex;
  font-family: PingFang-SC-Bold;
	font-size: 22px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.item, .text{
  /* flex: 1; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-i{
  min-height: 6vh;
  display: flex;
  background-color: #fff;
  border-bottom: 2px solid #e7e7e7;
  font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
}
.content-i:hover{
  background-color: #e1edf8;
}
.btn{
  display: flex;
  justify-content: center;
  font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0vh;
	color: #2e5be9;
}
.btn>.btn-l{
  margin-right: 5px;
}
.btn>.btn-l:hover{
  cursor: pointer;
  opacity: 0.7;
}
.btn>.btn-r{
  margin-left: 5px;
}
.btn>.btn-r:hover{
  cursor: pointer;
  opacity: 0.7;
}
.header{
  display: flex;
  min-height: 6vh;
  line-height: 6vh;
  font-family: PingFang-SC-Regular;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #000000;
}
.el-pagination{
  background-color: #dfe1e3;
}
.cont-box{
  overflow-y: hidden;
}
.title, .scroll{
  width: 100%;
}

.el-dialog__title{
  margin-left: 210px;
}
.dialog-footer{
  display: flex;
  justify-content: center;
}
.btns1{
  width: 65%;
  display: flex;
  justify-content: space-between;
}
.btn1{
  font-size: 16px;
  color: #2e5be9;
}
.btn1:hover{
  cursor: pointer;
  opacity: 0.7;
}
.red{
  color: #f00;
}
.el-pagination {
    padding: 1.2vh 1vh !important;
}
::v-deep .el-step__description{
  display: flex;
  flex-direction: column;
  font-size: 18px;
}
::v-deep .el-step__description>span{
  margin-bottom: 10px;
}
</style>